import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';

import { BoxDiv } from './box';

import pixu from '../assets/img/pixu_shouye_icon.png';
import qixu from '../assets/img/qixu_shouye_icon.png';
import shenxu from '../assets/img/shenxu_shouye_icon.png';
import tanshi from '../assets/img/tanshi_shouye_icon.png';
import xuexu from '../assets/img/xuexu_shouye_icon.png';
import yangxu from '../assets/img/yangxu_shouye_icon.png';
import yinxu from '../assets/img/yinxu_shouye_icon.png';
import yuzhi from '../assets/img/yuzhi_shouye_icon.png';
import jiankang from '../assets/img/jiankang_shouye_icon.png';
import StatusFlag from './status-flag';
import Definition from './definition';
import { scoreToColor, symptomNameTranslate } from './util';

const iconMap = {
  脾虚: pixu,
  气虚: qixu,
  肾虚: shenxu,
  痰湿: tanshi,
  血虚: xuexu,
  阳虚: yangxu,
  阴虚: yinxu,
  郁滞: yuzhi,
  健康: jiankang,
};

const Section = styled(BoxDiv)`
  border: none;
  border-bottom: 1px solid #f0f0f0;
  padding: 34px 40px 41px 40px;
  page-break-inside: avoid;
`;

class HealthSymptoms extends React.Component {
  renderOneSection(symptomName) {
    const { solutions, health_score } = this.props.examination;
    if (!solutions) return null;

    const explaining = solutions.symptom_definition;
    if (
      !explaining ||
      !explaining[symptomName] ||
      !explaining[symptomName].content
    ) return null;

    const [definition, ...reason] = explaining[symptomName].content;
    return (
      <Section key={symptomName}>
        <StatusFlag
          color={scoreToColor(health_score)}
          icon={iconMap[symptomName]}
          text={symptomNameTranslate(symptomName)} />
        <Definition
          name='定义'
          explain={[
            definition,
          ]} />
        <Definition
          name='原因'
          explain={reason.map((r, i) => `${i + 1}.${r}`)} />
      </Section>
    );
  }

  render() {
    const { symptoms } = this.props.examination;
    return symptoms.map(s => this.renderOneSection(s.name));
  }
}

HealthSymptoms.propTypes = {
  examination: PropTypes.object.isRequired,
};

export default HealthSymptoms;



// WEBPACK FOOTER //
// ./src/components/health-symptoms.jsx